/**
return string value with first character uppercase

@param input - String

*/
export default value => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};
